export default {
    iconos: [],
    epps: [
        {
            name: 'proteccion_ocular',
            text: 'PROTECCIÓN OCULAR',
            icons: [
                'img/epps/Ocular_1.jpg',
                'img/epps/Ocular_2.jpg',
                'img/epps/Ocular_3.jpg'
            ]
        },
        {
            name: 'proteccion_cutanea',
            text: 'PROTECCIÓN CUTÁNEA',
            icons: [
                'img/epps/Guantes.jpg'
            ]
        },
        {
            name: 'proteccion_respiratoria',
            text: 'PROTECCIÓN RESPIRATORIA',
            icons: [
                'img/epps/Respiratorio_1.jpg',
                'img/epps/Respiratorio_2.jpg',
                'img/epps/Respiratorio_3.jpg',
                'img/epps/Respiratorio_4.jpg'
            ]
        },
        {
            name: 'botas_calzado',
            text: 'BOTAS/CALZADO',
            icons: [
                'img/epps/Calzado.jpg'
            ]
        },
        {
            name: 'traje_ropa',
            text: 'TRAJE/ROPA',
            icons: [
                'img/epps/Traje_1.jpg',
                'img/epps/Traje_2.jpg'
            ]
        },
    ],
    proteccion_ocular: [
        'img/epps/Ocular_1.jpg',
        'img/epps/Ocular_2.jpg',
        'img/epps/Ocular_3.jpg'
    ],
    proteccion_cutanea: [
        'img/epps/Guantes.jpg'
    ],
    proteccion_respiratoria: [
        'img/epps/Respiratorio_1.jpg',
        'img/epps/Respiratorio_2.jpg',
        'img/epps/Respiratorio_3.jpg',
        'img/epps/Respiratorio_4.jpg'
    ],
    botas_calzado: [
        'img/epps/Calzado.jpg'
    ],
    traje_ropa: [
        'img/epps/Traje_1.jpg',
        'img/epps/Traje_2.jpg'
    ],
}
